import React, { useRef } from 'react'
import BroadcastsToolbarContent from '../__toolbarContent/broadcasts__toolbarContent'
import Sidebar from 'blocks.app/sidebar/sidebar'
import translate from 'core/translate'
import { api } from 'core/api/ConnectionManager'
import helpersBroadcasts from 'core/helpers/_broadcasts'
import helpers from 'core/helpers'
import { getParamsForMultipleMoveBroadcasts } from 'core/utils/broadcastUtil'
import { withRouter } from 'react-router'
import { SidebarMultiselectMenu } from 'blocks.app/sidebarMultiselectMenu/SidebarMultiselectMenu'
import { MenuItem } from '../../displays/__toolbarContent/displays__toolbarContent'

type SelectedItem = {
    id: number
    instanceType: string
}
type Data = {
    sourceId: number[]
    folderId: number[]
    newFolderId: number
}

const BroadcastsToolbar = (p_: any) => {
    const moveItemRef = useRef<any>(null)
    const deleteItemRef = useRef<any>(null)
    const deleteBroadcastFolders = () => {
        let idBroadcasts: number[] = []
        let idBroadcastsFolders: number[] = []

        p_.selectedItems.forEach((item: SelectedItem) => {
            if (helpersBroadcasts.isDirectory(item)) {
                idBroadcastsFolders.push(item.id)
            } else {
                idBroadcasts.push(item.id)
            }
        })

        const deletePromises = []
        if (idBroadcasts.length > 0) {
            deletePromises.push(api.send('deleteBroadcast', { id: idBroadcasts }))
        }

        if (idBroadcastsFolders.length > 0) {
            deletePromises.push(api.send('deleteBroadcastFolder', { id: idBroadcastsFolders }))
        }

        Promise.all(deletePromises).then(() => {
            p_.onChange([])
        })
    }

    const editBroadcastFolders = (data: Data) => {
        const params = getParamsForMultipleMoveBroadcasts(data.sourceId, data.folderId, data.newFolderId)
        api.send('moveToBroadcastFolder', params).then(() => {
            p_.onChange([])
        })
    }

    const renderTopContent = () => {
        return (
            <SidebarMultiselectMenu>
                <MenuItem
                    data={{ name: 'move' }}
                    onClick={() => {
                        moveItemRef.current()
                    }}
                />
                <MenuItem
                    data={{ name: 'delete' }}
                    onClick={() => {
                        deleteItemRef.current()
                    }}
                />
            </SidebarMultiselectMenu>
        )
    }

    return (
        <Sidebar
            selectedSide="right"
            onChange={(list: object[]) => p_.onChange(list)}
            customContent={{
                right: p_.selectedInfo ? <BroadcastsToolbarContent {...p_} /> : null,
            }}
            onGetFoldersOnMultiple={p_.onGetFoldersOnMultiple}
            content={{
                right: !p_.selectedInfo
                    ? {
                          title: translate('broadcasts'),
                          options: p_.selectedItems,
                          folders: p_.folders,
                          folderId: p_.folderId,
                          editTitle: translate('parentFolder'),
                          isDirectory: (option: { instanceType: string }) => helpersBroadcasts.isDirectory(option),
                      }
                    : null,
            }}
            topContent={{
                right: !p_.selectedInfo ? renderTopContent() : null,
            }}
            isEmpty={{
                right: !p_.selectedInfo && p_.selectedItems.length === 0,
            }}
            emptyText={{
                right: {
                    title: translate('noSelectTranslation'),
                    description: translate('noSelectedTranslationDescription'),
                },
            }}
            //isShowActions={true}
            isDeletable={p_.selectedItems.every((item: any) =>
                helpers.isAvailableAction(item, {
                    key: 'broadcast',
                    action: 'delete',
                })
            )}
            isEditable={p_.selectedItems.every((item: any) =>
                helpers.isAvailableAction(item, {
                    key: 'broadcast',
                    action: 'delete',
                })
            )}
            onSubmit={(side: string, type: string, data: Data) => {
                if (side === 'right' && type === 'delete') {
                    deleteBroadcastFolders()
                } else if (side === 'right' && type === 'edit') {
                    editBroadcastFolders(data)
                }
            }}
            moveItemRef={moveItemRef}
            deleteItemRef={deleteItemRef}
        />
    )
}

export default withRouter(BroadcastsToolbar)
